import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseHttpService } from '../base/base-http.service';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { listResponseModel, reportDesignerDto } from '../../models/base/base';

// export interface ReportDesignDto {
//   id?: string;
//   tabsystemmenuid?: string;
//   menukey: string;
//   pageparameters: string;
//   reportaraname: string;
//   reportlatname: string;
//   reportfilename: string;
//   active: boolean;
//   defaultreport: boolean;
// }

@Injectable({
  providedIn: 'root'
})
export class ReportDesignService extends BaseHttpService<reportDesignerDto> {

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getResourceUrl(): string {
    return 'ReportDesign';
  }

  // Override create method to use custom endpoint
  // create(data: ReportDesignDto): Observable<any> {
  //   const url = `${environment.baseUrl}/api/v1/ReportDesign/Create`;
  //   return this.httpClient.post(url, data);
  // }

  // // Override update method to use custom endpoint (Note: User specified Company/Update but this should be ReportDesign/Update)
  // update(data: ReportDesignDto): Observable<any> {
  //   const url = `${environment.baseUrl}/api/v1/ReportDesign/Update`;
  //   return this.httpClient.put(url, data);
  // }

  // // Override delete method to use custom endpoint
  // delete(id: string, data?: any): Observable<any> {
  //   console.log("data in service", data);
  //   if (!data.iscustom) {
  //     const url = `${environment.baseUrl}/api/v1/ReportDesign/Delete?Id=${id}`;
  //     return this.httpClient.delete(url);
  //   } else {
  //     this.toastr.warning(
  //       this.translate.instant('YouCantDeleteCustomReport'),
  //       this.translate.instant('warning')
  //     );
  //     return null;
  //   }


  // }

  // getAllReportsByMenuKey(menuKey: string, pageparamter: string | null): Observable<listResponseModel<reportDesignerDto>>{
    
  //   return this.httpClient.get<listResponseModel<reportDesignerDto>>(`${this.baseUrl}/GetReportsByTabSystemMenu?menukey=${menuKey}&pageparamter=${pageparamter}`);
  // }
  getAllReportsByMenuKey(
    menuKey: string,
    pageparamter: string | null
  ): Observable<listResponseModel<reportDesignerDto>> {
    let params = new HttpParams().set('menukey', menuKey);
    if (pageparamter !== null && pageparamter !== undefined && pageparamter !== '' && pageparamter !== 'null') {
      params = params.set('pageparamter', pageparamter);
    }
    return this.httpClient.get<listResponseModel<reportDesignerDto>>(
      `${this.baseUrl}/GetReportsByTabSystemMenu`,
      { params }
    );
  }
}
